import React from 'react'

import {
  Box,
  Color,
  Display,
  Text,
  Icon,
  IconVariant,
  AlignItems,
  BorderStyle,
} from '@gousto-internal/citrus-react'

export const InfoMessage = ({ text }: { text: string }) => {
  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.Center}
      color={Color.ColdGrey_900}
      paddingH={3}
      paddingV={4}
      style={{ margin: '1rem 0 1rem 0' }}
      bg={Color.Informative_50}
      borderColor={Color.Informative_200}
      borderWidth={0.5}
      borderStyle={BorderStyle.Solid}
      borderRadius={1.5}
    >
      <Box display={Display.Flex} alignItems={AlignItems.Center} gap={2}>
        <Icon name="info" variant={IconVariant.Informative}>
          Information
        </Icon>
        <Text>{text}</Text>
      </Box>
    </Box>
  )
}
